export default __webpack_public_path__ + "static/media/error.3223072f.png";